export default __webpack_public_path__ + "static/media/IMG_6253.8dd1eefb.jpg";